export default __webpack_public_path__ + "static/media/Map_Solar.a0154cf0.svg";